import Actions from '../constants/Actions';
import { ImmutableStore } from 'fluxible-immutable-utils';

const defaultState = {
  currentUrl: null,
  currentNavigationError: null,
  navigationComplete: true,
  currentLocation: '',
  currentRoutes: []
};

class RouteStore extends ImmutableStore {

  static storeName = 'RouteStore';

  static handlers = {
    [Actions.NAVIGATION__STARTED]: 'handleNavigateStart',
    [Actions.NAVIGATION__COMPLETED]: 'handleNavigateSuccess',
    [Actions.NAVIGATION__FAILED]: 'handleNavigateFailure'
  };

  constructor(dispatcher) {
    super(dispatcher);
    this.setState(defaultState);
  }

  handleNavigateStart({location, routes = []}) {
    const currentRoutes = routes.map(r => r.name);
    this.mergeState({
      currentNavigationError: null,
      navigationComplete: false,
      currentUrl: location.pathname + location.search,
      currentPath: location.pathname,
      currentRoutes
    });
  }

  handleNavigateSuccess() {
    this.mergeState({
      navigationComplete: true,
      currentNavigationError: null
    });
  }

  handleNavigateFailure(currentNavigationError) {
    this.mergeState({
      navigationComplete: true,
      currentNavigationError
    });
  }

  getCurrentRoutes() {
    return this.get('currentRoutes');
  }

  getCurrentNavigationError() {
    return this.get('currentNavigationError');
  }

  getCurrentUrl() {
    return this.get('currentUrl');
  }

  getCurrentPath() {
    return this.get('currentPath');
  }

  isNavigationComplete() {
    return this.get('navigationComplete');
  }
}

export default RouteStore;



// WEBPACK FOOTER //
// ./src/stores/RouteStore.js